module.exports = __webpack_public_path__ + "static/media/EN.83014edd.png";